<template>
  <div data-job-list-group v-show="shouldRender">
    <h2
      :class="options.view.theme === 'dark' ? $style.title : $style.lightTitle"
      :style="titleStyle">
      {{ group.name }}
    </h2>
    <job-list-items
      :items="group.vacancies"
      :options="options"
    />
  </div>
</template>

<script>
import JobListItems from './JobListItems'
import jobGroupTypes from './types/job-group'

export default {
  name: 'JobListGroup',

  props: jobGroupTypes,

  components: {
    JobListItems
  },

  computed: {
    headingsStyle () {
      return this.options.css.headings
    },
    shouldRender () {
      const visibleItems = this.group.vacancies.filter(vacancy => {
        const { tags, query } = vacancy.visibility
        return tags && query
      })
      return Boolean(this.group.vacancies.length && visibleItems.length)
    },

    titleStyle () {
      return {
        fontFamily: this.headingsStyle.fontFamily,
        fontWeight: this.headingsStyle.fontWeight,
        fontSize: this.headingsStyle.fontSize,
        lineHeight: this.headingsStyle.lineHeight
      }
    }
  }
}
</script>

<style module>
  .title {
    color: rgba(0,0,0,0.7);
    margin: 38px 0 20px 0px;
  }

  .lightTitle {
    composes: title;
    color: rgba(255,255,255,0.7);
  }
</style>
